import './popover.css';
export default {
  "modifiers": {
    "noPadding": "pf-m-no-padding",
    "widthAuto": "pf-m-width-auto",
    "top": "pf-m-top",
    "topLeft": "pf-m-top-left",
    "topRight": "pf-m-top-right",
    "bottom": "pf-m-bottom",
    "bottomLeft": "pf-m-bottom-left",
    "bottomRight": "pf-m-bottom-right",
    "left": "pf-m-left",
    "leftTop": "pf-m-left-top",
    "leftBottom": "pf-m-left-bottom",
    "right": "pf-m-right",
    "rightTop": "pf-m-right-top",
    "rightBottom": "pf-m-right-bottom",
    "danger": "pf-m-danger",
    "warning": "pf-m-warning",
    "success": "pf-m-success",
    "custom": "pf-m-custom",
    "info": "pf-m-info"
  },
  "popover": "pf-v6-c-popover",
  "popoverArrow": "pf-v6-c-popover__arrow",
  "popoverBody": "pf-v6-c-popover__body",
  "popoverClose": "pf-v6-c-popover__close",
  "popoverContent": "pf-v6-c-popover__content",
  "popoverFooter": "pf-v6-c-popover__footer",
  "popoverHeader": "pf-v6-c-popover__header",
  "popoverTitle": "pf-v6-c-popover__title",
  "popoverTitleIcon": "pf-v6-c-popover__title-icon",
  "popoverTitleText": "pf-v6-c-popover__title-text"
};